import React from 'react';

/**
 * Placeholder artwork for the tutorial steps.
 *
 * The outer composition (soft panel + floating dots + leaf) is shared by every
 * step so the tour reads as one system; only the glyph inside the dark card
 * changes per step. These are stand-ins — once the final illustrations land,
 * give the step an `image` in TUTORIAL_STEPS and this component is bypassed.
 */

const PANEL = '#E4F5EA';
const ACCENT = '#16A34A';
const SOFT = '#C6E7D0';
const DOT_LG = '#CDEBD8';
const DOT_SM = '#BFE5CC';

// Glyphs are drawn in the coordinate space of the dark card: x 61..164, y 12..100.
const GLYPHS = {
  chart: (
    <polyline
      points="74,84 94,60 110,71 130,45 152,26"
      fill="none"
      stroke="#FFFFFF"
      strokeWidth="5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
  grid: (
    <g fill="#FFFFFF">
      <rect x="74" y="26" width="42" height="28" rx="5" />
      <rect x="124" y="26" width="28" height="28" rx="5" />
      <rect x="74" y="60" width="28" height="28" rx="5" />
      <rect x="110" y="60" width="42" height="28" rx="5" />
    </g>
  ),
  chat: (
    <g fill="#FFFFFF">
      <path d="M78 26h70a8 8 0 0 1 8 8v34a8 8 0 0 1-8 8h-40l-16 14v-14h-14a8 8 0 0 1-8-8V34a8 8 0 0 1 8-8z" />
      <circle cx="96" cy="51" r="4" fill={ACCENT} />
      <circle cx="113" cy="51" r="4" fill={ACCENT} />
      <circle cx="130" cy="51" r="4" fill={ACCENT} />
    </g>
  ),
  bell: (
    <g fill="#FFFFFF">
      <path d="M112.5 22a22 22 0 0 1 22 22v18l7 10a3 3 0 0 1-2.5 4.7h-53a3 3 0 0 1-2.5-4.7l7-10V44a22 22 0 0 1 22-22z" />
      <path d="M104 82h17a8.5 8.5 0 0 1-17 0z" />
    </g>
  ),
  bars: (
    <g fill="#FFFFFF">
      <rect x="76" y="60" width="16" height="28" rx="4" />
      <rect x="100" y="44" width="16" height="44" rx="4" />
      <rect x="124" y="52" width="16" height="36" rx="4" />
      <rect x="148" y="30" width="16" height="58" rx="4" />
    </g>
  ),
};

const TutorialIllustration = ({ variant = 'chart', className = '' }) => (
  <svg
    viewBox="0 0 212 143"
    role="presentation"
    aria-hidden="true"
    className={className}
  >
    {/* Floating dots on the left */}
    <circle cx="15" cy="47" r="15" fill={DOT_LG} />
    <circle cx="28" cy="110" r="11" fill={DOT_SM} />

    {/* Leaf on the right */}
    <path
      d="M200 22c12 23 12 45 0 68-12-23-12-45 0-68z"
      fill={ACCENT}
    />

    {/* Soft panel */}
    <rect x="48" y="0" width="129" height="143" rx="16" fill={PANEL} />

    {/* Dark card + per-step glyph */}
    <rect x="61" y="12" width="103" height="88" rx="10" fill={ACCENT} />
    {GLYPHS[variant] || GLYPHS.chart}

    {/* Text placeholder lines under the card */}
    <rect x="61" y="109" width="103" height="10" rx="5" fill={SOFT} />
    <rect x="61" y="125" width="66" height="9" rx="4.5" fill={SOFT} />
  </svg>
);

export default TutorialIllustration;
